module.exports = "../../app/cells/pages/contests/index/contests_highlights_cell.rb";